import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import AuthApi from '../generated/api/Auth';

export default (service: Servicelayer) => ({
  ...AuthApi(service),

  // Add custom calls here

});
